(function(){
  var root=document.getElementById('tvk-catalog'); if(!root) return;
  var URLS={}; try{ URLS=JSON.parse(document.getElementById('tvk-urls').textContent); }catch(e){}
  var indexUrl=URLS.index;
  function assetUrl(model){ return URLS[model] || (URLS.index ? String(URLS.index).split('?')[0].replace('catalog-index.json', 'catalog-' + model + '.json') : undefined); }
  var panes={1:q('[data-pane="1"]'),2:q('[data-pane="2"]'),3:q('[data-pane="3"]')};
  var steps=[].slice.call(root.querySelectorAll('.tvk-steps li'));
  var modelsEl=q('#tvk-models'), mojeEl=q('#tvk-moje'), groupsEl=q('#tvk-groups');
  var curCatalog=null, curDrawing=null, zoom=1, fitScale=1, curName='';
  var rejstrikModelu=null;   // catalog-index.json — drzí se kvůli kategorii (Motokros, Enduro…)
  function applyZoom(){
    var inner=q('#tvk-inner'); if(!inner) return;
    inner.style.transform='scale('+zoom+')';
    inner.style.setProperty('--tvk-inv', String(1/zoom));
    var rel=zoom*fitScale; // pomer vuci nativni velikosti
    var zv=q('#tvk-zval'); if(zv) zv.textContent=Math.round(rel*100)+'%';
    var stage=q('.tvk-diag-stage'); if(stage) stage.classList.toggle('tvk-overview', rel<0.85);
  }
  var initTimer=null;
  function initNativeZoom(){
    if(initTimer){clearInterval(initTimer); initTimer=null;}
    var tries=0;
    initTimer=setInterval(function(){
      tries++;
      var inner=q('#tvk-inner'); var im=inner?inner.querySelector('img'):null; var stage=q('.tvk-diag-stage');
      if(im&&stage&&im.complete&&im.naturalWidth>0&&stage.clientWidth>50){
        clearInterval(initTimer); initTimer=null;
        fitScale=stage.clientWidth/im.naturalWidth;   // fit-width pomer (zaklad width:100%)
        zoom=fitScale<1 ? (1/fitScale) : 1;            // 1:1 (male obrazky nechat fit)
        applyZoom();
        stage.scrollTop=0; stage.scrollLeft=0;
      } else if(tries>40){ clearInterval(initTimer); initTimer=null; }
    },100);
  }

  function q(s){return root.querySelector(s);}
  function fmtCZK(v){ if(v==null) return ''; return new Intl.NumberFormat('cs-CZ',{style:'currency',currency:'CZK',maximumFractionDigits:0}).format(v); }

  function showStep(n){
    for(var k in panes){ panes[k].classList.toggle('tvk-hidden', String(k)!==String(n)); }
    steps.forEach(function(li){var s=+li.getAttribute('data-step');li.classList.toggle('is-active',s===n);li.classList.toggle('is-done',s<n);});
    window.scrollTo({top:root.offsetTop-20,behavior:'smooth'});
  }
  root.querySelectorAll('[data-goto]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();showStep(+a.getAttribute('data-goto'));});});

  // ── krok 1: dlaždice motorek ──
  var MOJE_KEY='tvk_moje_motorka';
  function mojeGet(){ try{ return JSON.parse(localStorage.getItem(MOJE_KEY)||'null'); }catch(e){ return null; } }
  function mojeSet(v){ try{ if(v) localStorage.setItem(MOJE_KEY, JSON.stringify(v)); else localStorage.removeItem(MOJE_KEY); }catch(e){} }

  function renderMoje(){
    if(!mojeEl) return;
    var m=mojeGet();
    if(!m){ mojeEl.classList.add('tvk-hidden'); mojeEl.innerHTML=''; return; }
    mojeEl.classList.remove('tvk-hidden');
    mojeEl.innerHTML='<div class="tvk-moje-in">'+
      '<span class="tvk-moje-star">★</span>'+
      '<span class="tvk-moje-txt"><small>Moje motorka</small><b>'+esc(m.name)+'</b></span>'+
      '<button type="button" class="tvk-moje-go">Pokračovat ›</button>'+
      '<button type="button" class="tvk-moje-x" aria-label="Zrušit uloženou motorku">×</button></div>';
    mojeEl.querySelector('.tvk-moje-go').addEventListener('click',function(){ selectModel(m.model, m.name); });
    mojeEl.querySelector('.tvk-moje-x').addEventListener('click',function(){ mojeSet(null); renderMoje(); });
  }

  function selectModel(model, displayName){
    groupsEl.innerHTML='<div class="tvk-loading">Načítám katalog…</div>';
    showStep(2);
    fetch(assetUrl(model)).then(function(r){return r.json();}).then(function(cat){
      curCatalog=cat; curName=displayName||cat.bikeName||model;
      mojeSet({model:model, name:curName});
      renderMoje();
      q('#tvk-bike2').textContent=curName;
      q('#tvk-bike3').textContent=curName;
      // Hlavička kroku 2 — stejně jako na KTM shopu: náhled motorky, název,
      // pod ním značka a kategorie. Obrázek nemusí být, pak se skryje.
      var im=q('#tvk-moto-img');
      if(im){ if(cat.thumb){ im.src=nahled(cat.thumb,300); im.alt=curName; im.classList.remove('tvk-hidden'); }
              else { im.removeAttribute('src'); im.classList.add('tvk-hidden'); } }
      var sub=q('#tvk-moto-sub');
      if(sub){ var kat=kategorieModelu(model); sub.textContent='Triumph'+(kat?' \u00b7 '+kat:''); }
      renderGroups(cat);
    }).catch(function(){ groupsEl.innerHTML='<div class="tvk-loading">Katalog se nepodařilo načíst.</div>'; });
  }

  fetch(indexUrl).then(function(r){return r.json();}).then(function(list){
    rejstrikModelu=list;
    renderMoje();
    modelsEl.innerHTML=list.map(function(m,mi){
      var btns=(m.vars||[]).map(function(v){
        var nm=m.name+(v.label && v.label.indexOf('Zobrazit')===-1 ? ' ('+v.label+')' : '');
        return '<button type="button" class="tvk-model-btn" data-model="'+esc(v.model)+'" data-name="'+esc(nm)+'">'+esc(v.label)+' ›</button>';
      }).join('');
      return '<div class="tvk-model-card" data-search="'+esc((m.name+' '+(m.kat||'')).toLowerCase())+'">'+
        '<div class="tvk-model-img"><img loading="lazy" src="'+esc(nahled(m.thumb,400))+'" alt="'+esc(m.name)+'"></div>'+
        '<div class="tvk-model-name">'+esc(m.name)+'</div>'+
        '<div class="tvk-model-kat">'+esc(m.kat||'')+'</div>'+
        '<div class="tvk-model-btns">'+btns+'</div></div>';
    }).join('');
    modelsEl.querySelectorAll('.tvk-model-btn').forEach(function(b){
      b.addEventListener('click',function(){ selectModel(b.getAttribute('data-model'), b.getAttribute('data-name')); });
    });
    var msearch=q('#tvk-model-search');
    if(msearch){
      msearch.addEventListener('input',function(){
        var f=(msearch.value||'').toLowerCase().replace(/\s+/g,' ').trim();
        var vis=0;
        modelsEl.querySelectorAll('.tvk-model-card').forEach(function(c){
          var ok=!f || (c.getAttribute('data-search')||'').indexOf(f)>-1;
          c.style.display=ok?'':'none'; if(ok)vis++;
        });
        var ne=q('#tvk-model-noresult');
        if(ne) ne.classList.toggle('tvk-hidden', vis>0);
      });
    }
  }).catch(function(){ modelsEl.innerHTML='<div class="tvk-loading">Katalog se nepodařilo načíst.</div>'; });

  // ── krok 2: oddíly Podvozek / Motor / Servis ──
  // Předloha: KTM shop, `finder-v18` ze 14. 9. 2026 — rozbor je v
  // `ktm-shopify-eshop/ANALYZA_ROZKRESY_VS_SPF_14-09-2026.md`. Výrobce posílá
  // 14 skupin v jednom plochém seznamu a v pořadí, ve kterém se motor s podvozkem
  // střídá (Hlava válce je až poslední) — zákazník pak roluje přes celý motor,
  // než se dostane k brzdám.
  //
  // ⛔ Je to JEN podání: v datech (`triumph_rozkresy`, `catalog-*.json`) se nemění
  // nic. Mapa níž je úplná — všech 14 skupin, ověřeno na všech 8 modelech
  // (ZB1 ZB2 ZD1 ZG1 ZJ1 ZR2 ZT2 ZY2, 21. 9. 2026). Co by do ní nesedlo (nová
  // skupina od výrobce), spadne do oddílu „Ostatní“ — ⛔ žádný výkres nesmí zmizet.
  var ODDILY=[
    {nazev:'Podvozek a karoserie', skupiny:[
      'Přední odpružení a řízení','Kyvná vidlice a zadní odpružení','Brzdy',
      'Kola a sekundární převod','Rám, stupačky a blatníky','Kapotáž a sedlo','Elektro']},
    {nazev:'Motor', skupiny:[
      'Hlava válce, písty a kliková hřídel','Kliková skříň a mazání',
      'Spojka a převodovka','Palivo a výfuk','Chlazení']},
    {nazev:'Servis a příslušenství', skupiny:['Servis','Příslušenství']}
  ];

  // Původní název skupiny u výrobce (obrácený `fix/sekce_cz.json`). Stejná řádka
  // jako `kf-nadskupina-orig` na KTM a stejná zvyklost jako „Původní název“ na
  // kartách dílů. ⚠ Chybějící záznam = prázdná řádka, ne chyba.
  var SKUPINA_EN={
    'Příslušenství':'Accessories',
    'Kapotáž a sedlo':'Bodywork, Screen & Seats',
    'Brzdy':'Braking System',
    'Spojka a převodovka':'Clutch, Transmission & Gearchange Mechanism',
    'Chlazení':'Cooling System',
    'Kliková skříň a mazání':'Crankcase, Engine Covers & Lubrication System',
    'Hlava válce, písty a kliková hřídel':'Cylinder Head, Valves, Pistons & Liners',
    'Elektro':'Electrical System',
    'Rám, stupačky a blatníky':'Frame, Footrests, Mudguards & Stands',
    'Přední odpružení a řízení':'Front Suspension, Steering & Clutch Controls',
    'Palivo a výfuk':'Fuel & Exhaust Systems',
    'Kyvná vidlice a zadní odpružení':'Rear Swinging Arm & Rear Suspension',
    'Servis':'Service',
    'Kola a sekundární převod':'Wheels & Final Drive'
  };

  /** České skloňování — ať to nehlásí „1 výkresů“. */
  function slovoVykres(n){ return n===1?'výkres':(n>=2&&n<=4?'výkresy':'výkresů'); }

  function kategorieModelu(model){
    if(!rejstrikModelu) return '';
    for(var i=0;i<rejstrikModelu.length;i++){
      var vars=rejstrikModelu[i].vars||[];
      for(var j=0;j<vars.length;j++) if(vars[j].model===model) return rejstrikModelu[i].kat||'';
    }
    return '';
  }

  /** Zmenseny nahled z Shopify CDN.
   * Karta vykresu je 160x120 px, ale obrazek od vyrobce ma 884x1250 a ~70 kB
   * -- pri 65 vykresech to bylo pres 4 MB a nahledy nabihaly pomalu (Vit 21. 9.).
   * `&width=` umi zmensit samo CDN. Vsech 626 adres v katalozich je
   * cdn.shopify.com a vsechny maji `?v=`, takze staci pripojit (overeno 21. 9.).
   * ⛔ Velky rozkres v kroku 3 sem NEPATRI -- ten se musi dat priblizit.
   * ⚠ Cizi adresa nebo uz zadana sirka se necha byt. */
  function nahled(url, sirka){
    var u=String(url||'');
    if(!u || u.indexOf('cdn.shopify.com')<0 || u.indexOf('width=')>-1) return u;
    return u+(u.indexOf('?')>-1?'&':'?')+'width='+sirka;
  }

  /** Jedna skupina: vlevo ikona a název, vpravo karty výkresů. */
  function skupinaHtml(g,gi){
    var ico=g.icon
      ? '<img class="tvk-skupina-ico" loading="lazy" src="'+esc(nahled(g.icon,120))+'" alt="">'
      : '<span class="tvk-skupina-ico tvk-skupina-ico-empty" aria-hidden="true"></span>';
    var en=SKUPINA_EN[g.name];
    var orig=en?'<span class="tvk-skupina-orig">'+esc(en)+'</span>':'';
    var karty=g.drawings.map(function(d,di){
      return '<button type="button" class="tvk-draw" data-g="'+gi+'" data-d="'+di+'">'+
        '<img loading="lazy" src="'+esc(nahled(d.image,400))+'" alt="">'+
        '<span class="tvk-draw-name">'+esc(d.name)+'</span></button>';
    }).join('');
    return '<div class="tvk-skupina" data-g="'+gi+'">'+
      '<div class="tvk-skupina-head">'+ico+
        '<span class="tvk-skupina-text"><span class="tvk-skupina-nazev">'+esc(g.name)+'</span>'+orig+'</span>'+
      '</div><div class="tvk-vykresy">'+karty+'</div></div>';
  }

  function renderGroups(cat){
    // ⚠ `gi` je pořadí skupiny v `cat.groups` a nese ho `openDrawing(gi,di)`
    // i výsledky hledání — oddíly mění jen pořadí NA OBRAZOVCE, index zůstává.
    var zbyva={}; cat.groups.forEach(function(g,gi){ zbyva[gi]=true; });
    var bloky=ODDILY.map(function(o){
      var gis=[];
      o.skupiny.forEach(function(jmeno){
        cat.groups.forEach(function(g,gi){
          if(g.name===jmeno && zbyva[gi]){ gis.push(gi); delete zbyva[gi]; }
        });
      });
      return {nazev:o.nazev, gis:gis};
    });
    var ostatni=Object.keys(zbyva).map(Number).sort(function(a,b){return a-b;});
    if(ostatni.length) bloky.push({nazev:'Ostatní', gis:ostatni});

    groupsEl.innerHTML=bloky.filter(function(b){return b.gis.length;}).map(function(b){
      var pocet=b.gis.reduce(function(s,gi){ return s+cat.groups[gi].drawings.length; },0);
      return '<section class="tvk-oddil tvk-oddil-zavreny">'+
        '<button type="button" class="tvk-oddil-head" aria-expanded="false">'+
          '<h3 class="tvk-oddil-nazev">'+esc(b.nazev)+'</h3>'+
          '<span class="tvk-oddil-pocet">'+pocet+' '+slovoVykres(pocet)+'</span>'+
          '<span class="tvk-oddil-chevron" aria-hidden="true">\u25b8</span>'+
        '</button>'+
        '<div class="tvk-oddil-telo">'+
          b.gis.map(function(gi){ return skupinaHtml(cat.groups[gi],gi); }).join('')+
        '</div></section>';
    }).join('');

    // Oddíly jsou na vstupu ZAVŘENÉ — stejně jako na KTM (Vít 14. 9.: ať se
    // k Motoru nemusí rolovat pod celý podvozek).
    groupsEl.querySelectorAll('.tvk-oddil-head').forEach(function(h){
      h.addEventListener('click',function(){
        var zavreny=h.parentNode.classList.toggle('tvk-oddil-zavreny');
        h.setAttribute('aria-expanded', zavreny?'false':'true');
        h.querySelector('.tvk-oddil-chevron').textContent = zavreny?'\u25b8':'\u25be';
      });
    });
    groupsEl.querySelectorAll('.tvk-draw').forEach(function(dv){
      dv.addEventListener('click',function(){ openDrawing(+dv.getAttribute('data-g'),+dv.getAttribute('data-d')); });
    });
    resetHledani();
  }

  // ── hledání dílu v CELÉ motorce (krok 2) ──
  // Předloha: `StepDrawings.tsx` na KTM shopu. Tam se rejstřík dílů dotahuje
  // líně z API; tady je celý katalog modelu (795–939 dílů) v paměti hned po
  // výběru motorky, takže hledání nestojí ani jeden request navíc.
  var MAX_NA_VYKRES=6;
  var hledaciPole=q('#tvk-group-search'), vysledkyEl=q('#tvk-search-results');

  /** Bez diakritiky a malými písmeny — ať „retez" najde „řetěz". */
  function bezDia(s){
    return String(s==null?'':s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  }

  function hledejDily(cat, dotaz){
    // Všechna slova dotazu musí sedět (AND) — „retez 520" tak najde řetěz 520
    // a ne všechno, co má v názvu 520.
    var slova=bezDia(dotaz).split(/\s+/).filter(Boolean);
    if(!slova.length) return null;
    var vykresy=[], celkem=0;
    cat.groups.forEach(function(g,gi){
      g.drawings.forEach(function(d,di){
        var trefy=[];
        d.parts.forEach(function(p,pi){
          var seno=bezDia((p.name||'')+' '+(p.sku||''));
          if(slova.every(function(w){ return seno.indexOf(w)>-1; })) trefy.push({p:p,i:pi});
        });
        if(trefy.length){ celkem+=trefy.length; vykresy.push({gi:gi,di:di,skupina:g.name,vykres:d.name,trefy:trefy}); }
      });
    });
    return {vykresy:vykresy, celkem:celkem};
  }

  /** České skloňování — ať to nehlásí „1 dílů". */
  function pocetDilu(n){ return n===1?'díl':(n>=2&&n<=4?'díly':'dílů'); }
  function pocetVykresu(n){ return n===1?'výkresu':'výkresech'; }

  function resetHledani(){
    if(hledaciPole) hledaciPole.value='';
    if(vysledkyEl){ vysledkyEl.innerHTML=''; vysledkyEl.classList.add('tvk-hidden'); }
    groupsEl.classList.remove('tvk-hidden');
  }

  function renderHledani(dotaz){
    if(!vysledkyEl) return;
    if(!curCatalog || bezDia(dotaz).trim().length<2){
      vysledkyEl.innerHTML=''; vysledkyEl.classList.add('tvk-hidden');
      groupsEl.classList.remove('tvk-hidden');
      return;
    }
    var r=hledejDily(curCatalog,dotaz);
    groupsEl.classList.add('tvk-hidden');
    vysledkyEl.classList.remove('tvk-hidden');
    if(!r||!r.vykresy.length){
      vysledkyEl.innerHTML='<div class="tvk-loading">Nic jsme nenašli. Zkus jiné slovo — hledá se v názvech dílů od výrobce a v objednacích číslech. Díl taky na téhle motorce být nemusí.</div>';
      return;
    }
    vysledkyEl.innerHTML='<p class="tvk-vysl-shrnuti">Nalezeno '+r.celkem+' '+pocetDilu(r.celkem)+
      ' v '+r.vykresy.length+' '+pocetVykresu(r.vykresy.length)+':</p>'+
      r.vykresy.map(function(v){
        var dily=v.trefy.slice(0,MAX_NA_VYKRES).map(function(t){
          return '<button type="button" class="tvk-vysl-dil" data-g="'+v.gi+'" data-d="'+v.di+'" data-i="'+t.i+'">'+
            '<span class="tvk-vysl-nazev">'+esc(t.p.name||'')+'</span>'+
            '<span class="tvk-vysl-sku">'+esc(t.p.sku||'')+'</span>'+
            '<span class="tvk-vysl-sipka" aria-hidden="true">\u2192</span></button>';
        }).join('');
        var vic=v.trefy.length>MAX_NA_VYKRES
          ? '<button type="button" class="tvk-vysl-vic" data-g="'+v.gi+'" data-d="'+v.di+'">\u2026a další '+
            (v.trefy.length-MAX_NA_VYKRES)+' ve výkresu — otevřít celý</button>'
          : '';
        return '<section class="tvk-vysl-vykres"><h4 class="tvk-vysl-nadpis">'+esc(v.vykres)+
          '<small>'+esc(v.skupina)+'</small></h4>'+dily+vic+'</section>';
      }).join('');
    vysledkyEl.querySelectorAll('.tvk-vysl-dil').forEach(function(b){
      b.addEventListener('click',function(){
        otevriZVysledku(+b.getAttribute('data-g'),+b.getAttribute('data-d'),+b.getAttribute('data-i'));
      });
    });
    vysledkyEl.querySelectorAll('.tvk-vysl-vic').forEach(function(b){
      b.addEventListener('click',function(){
        otevriZVysledku(+b.getAttribute('data-g'),+b.getAttribute('data-d'),-1);
      });
    });
  }

  function otevriZVysledku(gi,di,pi){
    openDrawing(gi,di);
    if(pi<0) return;
    // Rozkres i seznam dílů jsou v tuhle chvíli vykreslené, takže díl jde
    // zvýraznit rovnou — hi() rozsvítí pilulku ve výkresu i řádek v seznamu.
    root.querySelectorAll('.is-hi').forEach(function(e){e.classList.remove('is-hi');});
    hi(pi,true);
    // ⚠ scrollIntoView schválně NE — showStep(3) zrovna roluje stránkou
    // (smooth) a druhý scroll by se s ním pral. Posouvá se jen vnitřek
    // seznamu dílů, se stránkou to nehne.
    var row=q('.tvk-part[data-i="'+pi+'"]'), list=q('#tvk-parts-list');
    if(row&&list) list.scrollTop+=row.getBoundingClientRect().top-list.getBoundingClientRect().top
      -list.clientHeight/2+row.offsetHeight/2;
  }

  if(hledaciPole){
    hledaciPole.addEventListener('input',function(){ renderHledani(hledaciPole.value); });
    hledaciPole.addEventListener('keydown',function(e){ if(e.key==='Escape') resetHledani(); });
  }

  function openDrawing(gi,di){
    // Ať je při návratu („Zpět na rozkresy“) vidět, odkud se odešlo — oddíl
    // s touhle skupinou zůstane otevřený. Krok 2 se nepřekresluje, stačí třída.
    var sk=groupsEl.querySelector('.tvk-skupina[data-g="'+gi+'"]');
    var od=sk?sk.closest('.tvk-oddil'):null;
    if(od&&od.classList.contains('tvk-oddil-zavreny')){
      od.classList.remove('tvk-oddil-zavreny');
      var hh=od.querySelector('.tvk-oddil-head');
      if(hh){ hh.setAttribute('aria-expanded','true');
              var ch=hh.querySelector('.tvk-oddil-chevron'); if(ch) ch.textContent='\u25be'; }
    }
    var d=curCatalog.groups[gi].drawings[di]; curDrawing=d; zoom=1; fitScale=1;
    q('#tvk-draw-name').textContent=d.name;
    var img=q('#tvk-diag-img'); img.src=d.image;
    q('#tvk-zval').textContent='100%';
    var inner=q('#tvk-inner'); inner.style.transform='scale(1)'; inner.style.setProperty('--tvk-inv','1'); initNativeZoom();
    renderHotspots(d); renderParts(d.parts,''); showStep(3);
  }

  function renderHotspots(d){
    var wrap=q('#tvk-hotspots'); wrap.innerHTML='';
    d.parts.forEach(function(p,i){
      (p.hotspots||[]).forEach(function(hs){
        var el=document.createElement('div'); el.className='tvk-hs'; el.setAttribute('data-i',i);
        el.style.left=(hs.x/d.w*100)+'%'; el.style.top=(hs.y/d.h*100)+'%';
        el.style.width=(hs.w/d.w*100)+'%'; el.style.height=(hs.h/d.h*100)+'%';
        el.innerHTML='<b>'+esc(p.seq||'')+'</b>';
        el.addEventListener('mouseenter',function(){hi(i,true);});
        el.addEventListener('mouseleave',function(){hi(i,false);});
        el.addEventListener('click',function(){
          root.querySelectorAll('.is-hi').forEach(function(e){e.classList.remove('is-hi');});
          hi(i,true);
          var row=q('.tvk-part[data-i="'+i+'"]');if(row)row.scrollIntoView({block:'center',behavior:'smooth'});});
        wrap.appendChild(el);
      });
    });
  }

  function renderParts(parts,filter){
    var list=q('#tvk-parts-list'); var f=(filter||'').toLowerCase();
    var shown=parts.map(function(p,i){return {p:p,i:i};}).filter(function(o){
      if(!f) return true; return (o.p.name||'').toLowerCase().indexOf(f)>-1 || (o.p.sku||'').toLowerCase().indexOf(f)>-1;
    });
    q('#tvk-parts-count').textContent='Zobrazeno '+shown.length+' z '+parts.length;
    list.innerHTML=shown.map(function(o){
      var p=o.p; var qty=(p.qty&&p.qty>1)?'<span class="tvk-pqty">× '+p.qty+'</span>':'';
      var price=(p.czk!=null)?'<div class="tvk-pprice">'+fmtCZK(p.czk)+qty+'</div>':'';
      var link=p.handle?'/products/'+p.handle:'#';
      var add=(p.handle&&p.czk!=null)?'<button type="button" class="tvk-add" data-handle="'+esc(p.handle)+'">Do košíku</button>':'';
      return '<div class="tvk-part" data-i="'+o.i+'"'+((p.handle&&p.czk!=null)?' data-h="'+esc(p.handle)+'"':'')+'>'+
        '<div class="tvk-seq">'+esc(p.seq||'')+'</div>'+
        '<div class="tvk-pinfo"><div class="tvk-pname">'+esc(p.name)+'</div>'+
        '<div class="tvk-psku">'+esc(p.sku)+'</div>'+price+'</div>'+
        '<div class="tvk-pactions">'+add+'<a class="tvk-detail" href="'+link+'">Detail ›</a></div></div>';
    }).join('');
    list.querySelectorAll('.tvk-part').forEach(function(row){
      var i=+row.getAttribute('data-i');
      row.addEventListener('mouseenter',function(){hi(i,true);});
      row.addEventListener('mouseleave',function(){hi(i,false);});
    });
    list.querySelectorAll('.tvk-add').forEach(function(b){
      b.addEventListener('click',function(e){ e.stopPropagation(); addToCart(b.getAttribute('data-handle'), b); });
    });
    loadAvail();
  }

  var SF_TOKEN='28af480c55ad3f300cffae65a3c69c70';
  var availCache={};
  function loadAvail(){
    var rows=[].slice.call(root.querySelectorAll('.tvk-part[data-h]'));
    var need=[];
    rows.forEach(function(r){ var h=r.getAttribute('data-h'); if(h && !(h in availCache) && need.indexOf(h)<0) need.push(h); });
    function apply(){
      rows.forEach(function(r){
        var h=r.getAttribute('data-h'); var a=availCache[h]; if(a===undefined||a===null) return;
        var el=r.querySelector('.tvk-avail');
        if(!el){ el=document.createElement('div'); var info=r.querySelector('.tvk-pinfo'); if(!info) return; info.appendChild(el); }
        if(a.qty>0){ el.className='tvk-avail tvk-avail-in'; el.textContent='Skladem ve Vlašimi ('+a.qty+' ks)'; }
        else if(a.dost==='distributor'){ el.className='tvk-avail tvk-avail-mfr'; el.textContent='Skladem u dodavatele'; }
        else if(a.dost==='vyprodano'){ el.className='tvk-avail tvk-avail-order'; el.textContent='Momentálně vyprodáno u výrobce'; }  // 22. 9. 2026: stejné znění jako pilulka na kartě
        else { el.className='tvk-avail tvk-avail-order'; el.textContent='Na objednávku'; }
      });
    }
    if(!need.length){ apply(); return; }
    var chunks=[]; for(var i=0;i<need.length;i+=50) chunks.push(need.slice(i,i+50));
    var done=0;
    chunks.forEach(function(ch){
      var q='query{'+ch.map(function(h,i){ return 'p'+i+': product(handle:"'+h+'"){variants(first:1){nodes{quantityAvailable}} mf: metafield(namespace:"triumph",key:"vyrobce_dostupnost"){value}}'; }).join(' ')+'}';
      fetch('/api/2024-10/graphql.json',{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':SF_TOKEN},body:JSON.stringify({query:q})})
      .then(function(r){ return r.json(); }).then(function(d){
        ch.forEach(function(h,i){
          var p=d&&d.data&&d.data['p'+i]; var v=p&&p.variants&&p.variants.nodes&&p.variants.nodes[0];
          availCache[h]=v?{qty:(v.quantityAvailable||0),dost:((p&&p.mf&&p.mf.value)||'')}:null;
        });
        done++; if(done===chunks.length) apply();
      }).catch(function(){});
    });
  }

  function addToCart(handle,btn){
    if(!handle||btn.disabled) return;
    btn.disabled=true; var t0=btn.textContent; btn.textContent='Přidávám…';
    fetch('/products/'+handle+'.js').then(function(r){ if(!r.ok) throw new Error(); return r.json(); }).then(function(pr){
      var v=(pr.variants||[])[0]; if(!v) throw new Error();
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1})});
    }).then(function(r){ if(!r.ok) throw new Error();
      btn.textContent='✓ Přidáno'; btn.classList.add('is-ok');
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .header-cart-count, .head-slot-cart-link-quantity').forEach(function(el){ el.textContent=c.item_count; });
        document.querySelectorAll('.head-slot-cart-link-wrap').forEach(function(w){
          if(!w.querySelector('.head-slot-cart-link-quantity')){
            var s=document.createElement('span'); s.className='head-slot-cart-link-quantity'; s.textContent=c.item_count; w.appendChild(s);
          }
        });
      }).catch(function(){});
      setTimeout(function(){ btn.textContent=t0; btn.disabled=false; btn.classList.remove('is-ok'); }, 2500);
    }).catch(function(){
      btn.textContent='Chyba'; setTimeout(function(){ btn.textContent=t0; btn.disabled=false; }, 2000);
    });
  }

  function hi(i,on){
    root.querySelectorAll('.tvk-hs[data-i="'+i+'"]').forEach(function(e){e.classList.toggle('is-hi',on);});
    var row=q('.tvk-part[data-i="'+i+'"]'); if(row)row.classList.toggle('is-hi',on);
  }

  q('#tvk-part-search').addEventListener('input',function(e){ if(curDrawing) renderParts(curDrawing.parts,e.target.value); });

  root.querySelectorAll('.tvk-zoom button').forEach(function(b){
    b.addEventListener('click',function(){
      var z=b.getAttribute('data-z');
      var step=(fitScale<1?(1/fitScale):1)*0.25; // ctvrtina nativni velikosti
      if(z==='in')zoom=Math.min((fitScale<1?(1/fitScale):1)*3, zoom+step);
      else if(z==='out')zoom=Math.max(Math.min(1,(fitScale<1?(1/fitScale):1)*0.5), zoom-step);
      else zoom=1; // Cely vykres = fit
      applyZoom();
    });
  });

  // ── tažení rozkresu myší (drag-to-pan) ──
  // Postranní lišty na to nestačily: v nativním měřítku je výkres širší
  // i vyšší než okno. Prstem se na mobilu roluje nativně, tohle je pro myš.
  (function(){
    var stage=q('.tvk-diag-stage'); if(!stage) return;
    var tahne=false, hybal=false, potlacitKlik=false, x0=0, y0=0, sl0=0, st0=0;

    stage.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse'||e.button!==0) return;
      tahne=true; hybal=false;
      x0=e.clientX; y0=e.clientY; sl0=stage.scrollLeft; st0=stage.scrollTop;
      stage.classList.add('tvk-tahne');
    });

    // ⚠ posluchače na window, ne na stage — jinak by tažení „zamrzlo",
    // kdyby myš vyjela mimo výkres nebo mimo okno.
    window.addEventListener('pointermove',function(e){
      if(!tahne) return;
      var dx=e.clientX-x0, dy=e.clientY-y0;
      // Do 4 px je to pořád klik na díl, ne tažení.
      if(!hybal&&Math.abs(dx)+Math.abs(dy)<6) return;
      hybal=true;
      stage.scrollLeft=sl0-dx; stage.scrollTop=st0-dy;
      e.preventDefault();
    });

    function konec(){
      if(!tahne) return;
      tahne=false; stage.classList.remove('tvk-tahne');
      potlacitKlik=hybal;
    }
    window.addEventListener('pointerup',konec);
    window.addEventListener('pointercancel',konec);

    // Po tažení spolknout klik, ať tah přes pilulku nezvýrazní náhodný díl.
    stage.addEventListener('click',function(e){
      if(!potlacitKlik) return;
      potlacitKlik=false; e.stopPropagation(); e.preventDefault();
    },true);

    // Prohlížeč by jinak z obrázku udělal přetahovaný soubor.
    stage.addEventListener('dragstart',function(e){ e.preventDefault(); });
  })();

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
})();
